import { useEffect, useRef } from 'react';
import * as THREE from "three";
import useActiveListeners from "../../hooks/useActiveListeners";
import useIsMobile from "../../hooks/useIsMobile";

function latLngToVector3(lat, lng, radius) {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lng + 180) * (Math.PI / 180);

  return new THREE.Vector3(
    -radius * Math.sin(phi) * Math.cos(theta),
     radius * Math.cos(phi),
     radius * Math.sin(phi) * Math.sin(theta)
  );
}

export default function Globo() {
	const listeners = useActiveListeners();
	const isMobile = useIsMobile();
	const globeRef = useRef(null);
	const earthRef = useRef(null);

	function createFlagMarker(earth, lat, lng, country) {
		const texture = new THREE.TextureLoader().load(
			`https://flagcdn.com/w40/${country.toLowerCase()}.png`
		);

		const material = new THREE.SpriteMaterial({
			map: texture,
			transparent: true,
			depthTest: false
		});

		const sprite = new THREE.Sprite(material);

		sprite.scale.set(0.9, 0.6, 1);

		const pos = latLngToVector3(lat, lng, 5.15); // 👈 mayor al radio
		sprite.position.copy(pos);

		earth.add(sprite);
	}
	
	useEffect(() => {
		//Escena THREE
		const scene = new THREE.Scene();
		const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 1000);
		const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
		console.log(isMobile);
		isMobile ? renderer.setSize(70, 70) : renderer.setSize(150, 150);
		globeRef.current.appendChild(renderer.domElement);

		const geometry = new THREE.SphereGeometry(5, 32, 32);
		const texture = new THREE.TextureLoader().load(
			"https://unpkg.com/three-globe/example/img/earth-blue-marble.jpg"
		);
		const material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, opacity: 0.8 });
		const earth = new THREE.Mesh(geometry, material);
		earthRef.current = earth;
		scene.add(earth);

		camera.position.z = 14;

		const animate = () => {
			earth.rotation.y += 0.002;
			renderer.render(scene, camera);
			requestAnimationFrame(animate);
		};
		animate();

		return () => {
			globeRef.current.removeChild(renderer.domElement);
		};
	}, [isMobile]);
	
	useEffect(() => {
	  if (!earthRef.current) return;

	  // LIMPIAR
	  earthRef.current.children
		.filter(c => c.type === "Sprite")
		.forEach(c => earthRef.current.remove(c));

	  // AGREGAR
	  listeners.forEach(l => {
		if (!l?.lat || !l?.lng || !l?.country) return;
		createFlagMarker(earthRef.current, l.lat, l.lng, l.country);
	  });

	}, [listeners]);

	return (<>
		<div className="globo-container" ref={globeRef} />
		</>
	);
}
